import { render, staticRenderFns } from "./KontaktForm.vue?vue&type=template&id=48a9ab62&"
import script from "./KontaktForm.vue?vue&type=script&lang=js&"
export * from "./KontaktForm.vue?vue&type=script&lang=js&"
import style0 from "./KontaktForm.vue?vue&type=style&index=0&id=48a9ab62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports